import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ToastService } from '@services/toast/toast.service';
import { ICON_MAP } from '@shared/constants/toast';

@Component({
  selector: 'app-toast',
  imports: [CommonModule, MatIconModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent implements OnInit {
  readonly toastService = inject(ToastService)
  description = '';
  note = '';
  type = 'info';
  title = '';
  showToast = false;
  iconMap = ICON_MAP;
  
  get icon(): string {
    return this.iconMap[this.type] || 'info';
  }

  ngOnInit(): void {
    this.toastService.toastState.subscribe((state) => {
      this.type = state.type || 'info';
      this.showToast = state.show;
      this.description = state.message;
      this.note = state.note || '';
      this.title = state.type;
    });
  }

onClose(){
  this.showToast = false;
}
  
}
